import styled from "@emotion/styled";
import { Button } from "@mui/material"

export const ClipPage = styled.div`
  padding: 28px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 16px 0;
  }
`;

export const CardContainer = styled.div`
  width: 300px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  position: relative;
  background: ${({ theme }) => theme.palette.primary.dark2};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
  }
`;

export const ThumbnailContainer = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;
  overflow: hidden;
  aspect-ratio: 16 / 9;
  background: #000;
`;

export const PlayerLoaderBackdrop = styled.div`
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
`;

export const PlayerLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .MuiCircularProgress-root {
    color: rgba(247, 250, 250, 0.9);
  }
`;

export const PlayOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  padding: ${({ theme }) => theme.spacing('medium')};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BadgeContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
`;

export const CardContent = styled.div`
  padding: 15px;
  background-color: transparent; /* No background color */
`;

export const Title = styled.h3`
  font-size: 1.1rem;
  color: #fff;
`;

export const Description = styled.p`
  font-size: 0.9rem;
  margin: 5px 0;
  color: #aaa;
`;

export const MetaInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing('medium')};
`;

export const DateText = styled.span`
  font-size: 0.8rem;
  color: #bbb;
`;

export const Badge = styled.span`
  background-color: ${(props) => {
  switch (props.type) {
    case 'FOUR_K':
      return '#4caf50'; // Green for FOUR_K
    case 'HD_PLUS':
      return '#FF9800'; // Orange for HD_PLUS
    case 'HD':
      return '#f44336'; // Red for HD
    default:
      return '#000'; // Default color if none match
  }
}};
  color: #fff;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: bold;
`;

export const GridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing('large')};
  padding-block: ${({ theme }) => theme.spacing('large')};
  padding-inline: ${({ theme }) => theme.spacing('medium')};
  flex-direction: row;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    width: 100%;
    margin-left: 0%;
    padding-block: 10px;
  }
`;

export const ClipInputWrapper = styled.div`
  flex-grow: 1;
  align-items: center;
  gap: 16px;
  padding: ${({ theme }) => theme.spacing('large')};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;           // Stack elements vertically on mobile devices
    align-items: stretch;             // Ensure the items stretch on mobile
    gap: 10px;  
    width: 100%;
    padding: 10px; 
  }
`;

export const ClipsTitle = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.h2}; /* Use large font size from the theme */
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text.primary}; /* Use primary text color from the theme */
  margin-bottom: ${({ theme }) => theme.spacing('medium')}; /* Space between title and counters */
  margin-left: 5px;
  margin-top: 16px;
`;

export const DateRangePickerWrapper = styled.div`
  .rdrCalendarWrapper {
    background-color: #181b24; /* Dark background */
    color: #c7c7c7; /* Lighter text color */
    border-radius: 10px;
    padding: 20px;
  }

  .rdrMonthAndYearPickers select {
    background-color: #181b24; /* Dropdown background */
    color: #fff;
    border: none;
  }

  .rdrDateDisplay {
    background-color: #22252e; /* Input background */
    border: 1px solid #30303d;
  }

  .rdrDateDisplay input {
    background-color: #22252e;
    color: #fff;
    border: 1px solid #30303d;
    border-radius: 4px;
  }

  .rdrDefinedRangesWrapper {
    background-color: #1c1e26; /* Left panel background */
    border-right: 1px solid #30303d;
  }

  .rdrDefinedRangesItem {
    color: #fff;
  }

  .rdrDayDisabled {
    color: #555;
  }

  .rdrDayNumber span {
    color: #c7c7c7; /* Default day color */
  }

  .rdrDayToday .rdrDayNumber span {
    border: 1px solid #4d90fe; /* Border for today's date */
  }

  .rdrDayInPreview {
    background-color: rgba(77, 144, 254, 0.3); /* Preview range background */
  }

  .rdrDayStartPreview,
  .rdrDayEndPreview {
    background-color: #4d90fe; /* Selected preview start/end date */
    color: white;
  }

  .rdrDayHovered .rdrDayNumber span {
    background-color: rgba(77, 144, 254, 0.7); /* Hovered day background */
    color: white;
  }

  .rdrDayActive .rdrDayNumber span {
    background-color: #6d54e0; /* Active selected date */
    color: white;
    border-radius: 4px;
  }

  .rdrNextPrevButton {
    background-color: transparent; /* Remove default button color */
    color: #fff; /* Make arrows white */
  }

  .rdrStaticRanges li,
  .rdrInputRanges li {
    color: #fff; /* Text color for custom ranges */
  }

  .rdrStaticRangeSelected {
    background-color: #6d54e0; /* Selected range background */
  }

  .rdrDefinedRangesItem:hover {
    background-color: rgba(109, 84, 224, 0.3); /* Hover background for custom ranges */
  }

  .rdrDateRangePickerWrapper .rdrDateDisplayWrapper .rdrDateDisplayItem input {
    color: #fff;
    background-color: #22252e;
    border: 1px solid #30303d;
  }

  /* Buttons */
  .rdrDateRangePickerWrapper .rdrButton {
    background-color: #6d54e0; /* Apply button background */
    color: white;
  }

  .rdrDateRangePickerWrapper .rdrButton:hover {
    background-color: #5c47c0;
  }

  .rdrCancelButton {
    background-color: transparent;
    color: #c7c7c7;
  }

  .rdrCancelButton:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const MetaDivider = styled.div`
  width: 100%;
  height: 1px;
  margin: 10px 0 10px;
  background: linear-gradient(
    90deg,
    rgba(128, 149, 183, 0),
    rgba(128, 149, 183, 0.35),
    rgba(128, 149, 183, 0)
  );
`;

export const MetaList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MetaLabel = styled.span`
  color: rgba(247, 250, 250, 0.7);
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
`;

export const MetaRow = styled.div`
  display: flex;
  flex-direction: column; /* label on first line, value on next line */
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  min-width: 0;
`;

export const MetaValue = styled.span`
  color: #fff;
  font-size: 0.8rem;
  width: 100%;
  min-width: 0;

  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
`;

export const CustomButton = styled(Button)({
  backgroundColor: '#8a2be2',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#6c20bb',
  },
  '&.Mui-disabled': {
    backgroundColor: '#3a3a3a',
    color: '#9e9e9e',
  },
});
